import { Component, OnInit } from '@angular/core';
import { Onderneming } from 'src/app/models/Onderneming';
import { IFormBuilder, IFormGroup } from '@rxweb/types';
import { Subject } from 'rxjs';
import { FormBuilder, Validators } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { OndernemingService } from 'src/app/services/onderneming.service';
import { takeUntil } from 'rxjs/operators';
import { User } from 'src/app/models/User';
import { AuthService } from 'src/app/services/auth.service';
interface UserForm {
  email: string | null;
  wachtwoord: string | null;
  adminVan: string | null;
  isAdmin: boolean | false;
}
@Component({
  selector: 'app-private-admin',
  templateUrl: './private-admin.component.html',
  styleUrls: ['./private-admin.component.scss']
})

export class PrivateAdminComponent implements OnInit {

  onderneming: Onderneming = {
    naam: '',
    kleur: '',
    kleurKnoppen: '',
    id: '',
    vaa: '',
    cash4Bike: '',
    cash4Car: '',
    algemeneWaarschuwing: '',
    aanwerfSimulator: '',
    holidayValue: '',
    customLink: '',
    logo_id: '',
  }
  // user:User = {
  //   uid:'',
  //   email:'',
  //   adminVan:'',
  //   isAdmin: false
  // }
  constructor(formBuilder: FormBuilder,
    private afs: AngularFirestore,
    private authService: AuthService,
    private ondernemingService: OndernemingService) { this.formBuilder = formBuilder }
  componentDestoryed$: Subject<boolean> = new Subject();

  //form variabelen
  formBuilder: IFormBuilder;
  ondernemingFormGroup: IFormGroup<Onderneming>;
  deleteFormGroup: IFormGroup<Onderneming>;
  addUserFormGroup: IFormGroup<UserForm>;

  ondernemingen: Onderneming[];

  ngOnInit(): void {
    this.addUserFormGroup = this.formBuilder.group<UserForm>({
      wachtwoord:this.formBuilder.control(null, [Validators.required]),
      email: this.formBuilder.control(null, [Validators.required]),
      adminVan: this.formBuilder.control(null, [Validators.required]),
      isAdmin: this.formBuilder.control(false),
    });

    this.ondernemingFormGroup = this.formBuilder.group<Onderneming>({
      naam: this.formBuilder.control(null, [Validators.required]),
      kleur: this.formBuilder.control(null, [Validators.required]),
      kleurKnoppen: this.formBuilder.control(null, [Validators.required])
    });
    this.deleteFormGroup = this.formBuilder.group<Onderneming>({
      id: this.formBuilder.control(null, [Validators.required]),
    });
    
    this.getAllOndernemingen();
  }
  getAllOndernemingen()
  {
    this.ondernemingService.getAllOndernemingen().pipe(takeUntil(this.componentDestoryed$)).subscribe(e => {
      this.ondernemingen = e;
    })
  }
  async addUser()
  {
    
    let resp: any;
    resp = await this.authService.addUser(this.addUserFormGroup.value.email, this.addUserFormGroup.value.wachtwoord);
    
    const user: User  ={
      uid: resp.user.uid,
      email: this.addUserFormGroup.value.email,
      adminVan: this.addUserFormGroup.value.adminVan,
      isAdmin: true,

    };

 
    await this.authService.SetUserData(user);
  }
  onSubmit() {
    this.onderneming.naam = this.ondernemingFormGroup.value.naam;
    this.onderneming.kleur = this.ondernemingFormGroup.value.kleur;
    this.onderneming.kleurKnoppen = this.ondernemingFormGroup.value.kleurKnoppen;


    this.ondernemingService.addOnderneming(this.onderneming);

  }
  delete() {
    this.ondernemingService.getOndernemingId(this.deleteFormGroup.value.id).pipe(takeUntil(this.componentDestoryed$)).subscribe(o => {
      this.ondernemingService.deleteOnderneming(o);
    });

  }

  //Auto unsub
  ngOnDestroy() {
    this.componentDestoryed$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.componentDestoryed$.unsubscribe();
  }
}
